import { CALL_API } from '../../middleware/api';

export const GET_REPORT_REQUEST = 'GET_REPORT_REQUEST';
export const GET_REPORT_SUCCESS = 'GET_REPORT__SUCCESS';
export const GET_REPORT_FAILURE = 'GET_REPORT__FAILURE';

export function getList(params) {
  return {
    [CALL_API]: {
      types: [GET_REPORT_REQUEST, GET_REPORT_SUCCESS, GET_REPORT_FAILURE],
      endpoint: 'attendance/index/search',
      methods: 'GET',
      params
    }
  }
};

export function update(params) {
  return {
    [CALL_API]: {
      types: ['UPDATE_REPORT_REQUEST', 'UPDATE_REPORT_SUCCESS', 'UPDATE_REPORT_FAILURE'],
      endpoint: 'attendance/index/update-status',
      methods: 'POST',
      params
    }
  }
};

export function importExcel(params) {
  return {
    [CALL_API]: {
      types: ['IMPORT_EXCEL_REQUEST', 'IMPORT_EXCEL_SUCCESS', 'IMPORT_EXCEL_FAILURE'],
      endpoint: 'attendance/index/import',
      methods: 'POST',
      params,
    }
  }
};



// WEBPACK FOOTER //
// ./src/action/attendance/report.js